import { createContext } from 'react'

const petContext = createContext(null)

export default petContext